/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Op_NeInputs */

const cs_op_ne = /** @type {(inputs: Op_NeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nerovná se`)
};

const en_op_ne = /** @type {(inputs: Op_NeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not equals`)
};

/**
* | output |
* | --- |
* | "not equals" |
*
* @param {Op_NeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const op_ne = /** @type {((inputs?: Op_NeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Op_NeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_op_ne(inputs)
	return cs_op_ne(inputs)
});